import { render, staticRenderFns } from "./BidExecutedTrades.vue?vue&type=template&id=06a01c60&scoped=true&"
import script from "./BidExecutedTrades.vue?vue&type=script&lang=js&"
export * from "./BidExecutedTrades.vue?vue&type=script&lang=js&"
import style0 from "./BidExecutedTrades.vue?vue&type=style&index=0&id=06a01c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a01c60",
  null
  
)

export default component.exports